import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import {
  SecondaryCriteriaElementType,
  SecondaryCriteriaTemplate,
} from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  template: SecondaryCriteriaTemplate;
  retrieveSecondaryCriteriaTemplate(
    request: Boundaries["retrieveSecondaryCriteriaTemplate"]["request"],
  ): void;
}

function useRetrieveSecondaryCriteriaTemplate(
  namespace: string,
  type: SecondaryCriteriaElementType,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveSecondaryCriteriaTemplateRequestPending(
        namespace,
        type,
      ),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveSecondaryCriteriaTemplateRequestSuccess(
        namespace,
        type,
      ),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveSecondaryCriteriaTemplateRequestFailure(
        namespace,
        type,
      ),
    ),
    template: useSelector(() =>
      selector.getSecondaryCriteriaTemplate(namespace, type),
    ),
    retrieveSecondaryCriteriaTemplate: core.retrieveSecondaryCriteriaTemplate,
  };
}

export { useRetrieveSecondaryCriteriaTemplate };
